import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';

import { AppService, AuthService, NotificationService } from '@core/services';

@Injectable({
    providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router, private appService: AppService, private notificationService: NotificationService) {}

    /**
     * Intercept HTTP requests, set JWT in the request headers, and redirect on 401 UNAUTHORIZED errors.
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authService.getAccessToken();
        let modReq = req;

        if (token) {
            modReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + token),
            });
        }
        // If a user with a valid auth token still wants to use the end-user token, it gets priority over the logged in user
        if (this.authService.endUserToken) {
            modReq = req.clone({
                headers: req.headers.set('X-User-Token', this.authService.endUserToken.token),
            });
        }

        modReq = modReq.clone({
            headers: modReq.headers.set('Accept-Language', this.appService.getCurrentLocale()),
        });

        // Handle the modified request, and check for 401 errors.
        return next.handle(modReq).pipe(
            catchError((error) => {
                // Also check 403 with no user because dj-rest-auth does not like using HTTP codes as they're intended to be used
                if (error.status === 401 || error.status === 403 && this.authService.activeUser.getValue() === undefined) {
                    this.authService.activeUser.next(undefined);
                    this.authService.setLoginRedirect(this.router.url);
                    this.router.navigate(['/']);
                }
                // For authenticated users, surface backend 403 details so users know to activate the app
                if (error.status === 403 && this.authService.activeUser.getValue() !== undefined) {
                    const backendDetail: string | undefined = error?.error?.detail;
                    if (backendDetail) {
                        this.notificationService.errorMessage(backendDetail);
                    }
                }
                return throwError(() => error);
            }),
        );
    }
}
